import axios from '../../axios.js'

export default {
  addRecords(context, items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/billing-doc-linkages/bulk', { bulk: items })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeLinkage(context, linkage) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/billing-doc-linkages/remove_linkages`, {
          data: { docNo: linkage.docNo, docType: linkage.docType, linkedDocNo: linkage.linkedDocNo , linkedDocType: linkage.linkedDocType },
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeRecord({ commit }, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/billing-docs-linkages/${encodeURIComponent(docNo)}`)
        .then((response) => {
          commit('DELETE_DOCUMENT', docNo)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  bulkApplyCN(context, items) {
    return new Promise((resolve, reject) => {
      axios.post('/billing-doc-linkages/bulk-apply-cn')
    })
  },
}
